<template>
    <div class="container" id="ProfileForm">

        <form>
            <div class="form-group">
                <label>Username</label>
                <p class="lead">{{username}}</p>
            </div>
            <div class="form-group">
                <label>E-Mail</label>
                <input type="text" v-model="email" placeholder="E-Mail" class="form-control" :class="{error: mailCls}">
            </div>
            <i-button class="btn btn-primary" :click="changeMail" :isLoading="mailLoading">Change E-Mail</i-button>
            <hr>
            <h3>Change Password</h3>
            <div class="form-group">
                <label>New Password</label>
                <input type="password" v-model="password" placeholder="Password" class="form-control" :class="{error: pwCls}">
            </div>
            <div class="form-group">
                <label>Confirm new Password</label>
                <input type="password" v-model="passwordConfirm" placeholder="Confirm Password" class="form-control" :class="{error: pwcCls}">
            </div>
            <i-button class="btn btn-primary" :click="changePassword" :isLoading="pwLoading">Change Password</i-button>

            <hr>
            <h3>Content Filter</h3>
            <content-type-selector :types="contentTypes"/>

            <hr>
            <h3>Delete Account</h3>
            <i-button class="btn btn-sm btn-danger" :click.prevent="deleteAccount" :isLoading="deleteLoading">Delete your pimblr account</i-button>

        </form>



        
    </div>
</template>

<script>

    import iButton from '../ui/buttons/IndicatorButton.vue';
    import ContentTypeSelector from "../ui/buttons/ContentTypeSelector";

    export default {
        name: 'RegistrationForm',
        data(){
            return {
                email: '',
                username: '',
                password: '',
                passwordConfirm: '',
                mailCls: '',
                userCls: '',
                pwCls: '',
                pwcCls: '',
                mailLoading: false,
                pwLoading: false,
                deleteLoading: false,
                contentTypes: []
            }
        },
        mounted(){
            this.$api.getUserInfo()
                .then((res)=>{
                    this.username = res.data.user.name;
                    this.email = res.data.user.email;
                    this.contentTypes = res.data.user.contentTypes;
                })
        },
        methods: {

            changeMail(){
                this.mailLoading = true;
                this.$api.changeUserEmail(this.email)
                    .then((res)=>{
                        this.$bus.$emit('success', 'The E-Mail address was saved!');
                        this.mailLoading = false;
                    }).catch(()=>this.mailLoading = false)
            },

            changePassword(){

                this.pwCls = false;
                this.pwcCls = false;
                let pwLen = this.password.length;
                if(pwLen < 6){
                    this.pwCls = true;
                    this.$bus.$emit('error', 'Please enter a valid password with at least 6 chars');
                    return false;
                }
                if(this.password !== this.passwordConfirm){
                    this.pwCls = true;
                    this.pwcCls = true;
                    this.$bus.$emit('error', 'The passwords do not match');
                    return false;
                }

                this.pwLoading = true;
                this.$api.changeUserPassowrd(this.password)
                    .then((res)=>{
                        this.pwLoading = false;
                        this.password = '';
                        this.passwordConfirm = '';
                        this.$bus.$emit('success', res.data.message);
                    }).catch(()=>this.pwLoading = false)
            },

            deleteAccount(){
              this.deleteLoading = true;
              let conf = confirm('Are you sure, you want to delete your pimblr account? All your blogs, all your posts will be deleted!')
              if(conf){
                let pw = prompt('Please enter your password to delete your account:')
                this.$api.deleteUserAccount(this.$store.getters['user/id'], pw)
                  .then((res)=>{
                    console.log(res);
                    this.$store.commit('user/unsetToken');
                    this.$router.push({name: 'AccountDeleted'})
                    this.deleteLoading = false;
                  })
                  .catch(()=>{
                    this.deleteLoading = false;
                  })
              } else {
                this.deleteLoading = false;
              }

            }

        },
        components:{
            ContentTypeSelector,
            iButton
        }

    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/components/user/ProfileForm.vue